import React from "react";

const svgProps = {
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
};

const icons = {
  vocational: (
    <svg {...svgProps}>
      <path
        d="M18 40l8-8 6 6 14-14"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 52V20a4 4 0 014-4h24a4 4 0 014 4v32"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M28 16V12h8v4"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <circle cx="46" cy="46" r="8" stroke="currentColor" strokeWidth="3.5" />
      <path
        d="M46 42v8M42 46h8"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  ),
  collaborative: (
    <svg {...svgProps}>
      <circle cx="22" cy="22" r="8" stroke="currentColor" strokeWidth="3.5" />
      <circle cx="42" cy="22" r="8" stroke="currentColor" strokeWidth="3.5" />
      <path
        d="M10 48c2-8 8-12 12-12s10 4 12 12"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M30 48c2-8 8-12 12-12s10 4 12 12"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  mentalHealth: (
    <svg {...svgProps}>
      <path
        d="M32 46c14-10 20-18 20-26a12 12 0 00-20-8 12 12 0 00-20 8c0 8 6 16 20 26z"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <path
        d="M24 28h16M32 22v12"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  ),
  healthcare: (
    <svg {...svgProps}>
      <path
        d="M20 12h24a4 4 0 014 4v32a4 4 0 01-4 4H20a4 4 0 01-4-4V16a4 4 0 014-4z"
        stroke="currentColor"
        strokeWidth="3.5"
      />
      <path
        d="M28 28h8M32 24v8"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M22 44h20"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  diabetes: (
    <svg {...svgProps}>
      <path
        d="M32 10c8 10 16 18 16 28a16 16 0 11-32 0c0-10 8-18 16-28z"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="38" r="4" fill="currentColor" />
    </svg>
  ),
  mobileClinics: (
    <svg {...svgProps}>
      <path
        d="M8 40V24a4 4 0 014-4h24l10 10v10"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <path
        d="M8 40h48v4a2 2 0 01-2 2H10a2 2 0 01-2-2v-4z"
        stroke="currentColor"
        strokeWidth="3.5"
      />
      <circle cx="18" cy="48" r="4" stroke="currentColor" strokeWidth="3" />
      <circle cx="46" cy="48" r="4" stroke="currentColor" strokeWidth="3" />
      <path
        d="M28 26h6M31 23v6"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  ),
  ecosoc: (
    <svg {...svgProps}>
      <circle cx="32" cy="32" r="20" stroke="currentColor" strokeWidth="3.5" />
      <path
        d="M12 32h40M32 12c6 8 8 16 8 20s-2 12-8 20c-6-8-8-16-8-20s2-12 8-20z"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M16 22h32M16 42h32"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  childcare: (
    <svg {...svgProps}>
      <circle cx="32" cy="18" r="8" stroke="currentColor" strokeWidth="3.5" />
      <path
        d="M18 52c2-12 8-18 14-18s12 6 14 18"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M22 34c-4 2-8 8-8 14M42 34c4 2 8 8 8 14"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  lactation: (
    <svg {...svgProps}>
      <path
        d="M32 48c12-8 18-16 18-24a10 10 0 00-18-6 10 10 0 00-18 6c0 8 6 16 18 24z"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="18" r="5" stroke="currentColor" strokeWidth="3" />
      <circle cx="40" cy="18" r="5" stroke="currentColor" strokeWidth="3" />
      <path
        d="M20 12c0-4 3-7 6-7M44 12c0-4-3-7-6-7"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  ),
  workforce: (
    <svg {...svgProps}>
      <path
        d="M12 26h40v24a4 4 0 01-4 4H16a4 4 0 01-4-4V26z"
        stroke="currentColor"
        strokeWidth="3.5"
      />
      <path
        d="M24 26V18a4 4 0 014-4h8a4 4 0 014 4v8"
        stroke="currentColor"
        strokeWidth="3.5"
      />
      <path
        d="M12 36h40"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  education: (
    <svg {...svgProps}>
      <path
        d="M8 28l24-12 24 12-24 12L8 28z"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <path
        d="M18 33v10c6 4 14 4 20 0V33"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <path
        d="M52 28v16"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  socialServices: (
    <svg {...svgProps}>
      <circle cx="32" cy="16" r="7" stroke="currentColor" strokeWidth="3.5" />
      <path
        d="M18 54c2-14 8-20 14-20s12 6 14 20"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M14 34h12l4 8 6-14 4 6h10"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  partnership: (
    <svg {...svgProps}>
      <path
        d="M20 28c-6 0-10 4-10 10v6h14v-6c0-4 2-7 6-8"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44 28c6 0 10 4 10 10v6H40v-6c0-4-2-7-6-8"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="22" cy="18" r="7" stroke="currentColor" strokeWidth="3.5" />
      <circle cx="42" cy="18" r="7" stroke="currentColor" strokeWidth="3.5" />
    </svg>
  ),
};

const programIconKeys = [
  "vocational",
  "collaborative",
  "mentalHealth",
  "healthcare",
  "diabetes",
  "mobileClinics",
  "ecosoc",
  "childcare",
  "lactation",
  "workforce",
  "education",
  "socialServices",
];

export const getProgramIconKey = (index) =>
  programIconKeys[index] || "healthcare";

const ProgramIcon = ({ name, className }) => (
  <span className={className}>{icons[name] || icons.healthcare}</span>
);

export default ProgramIcon;
